(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });
  document.addEventListener('click', function(event) {

  const arrow = event.target.closest('.nested-submenu-arrow');

  /* CLICKING THE ARROW */
  if (arrow) {
    event.preventDefault();
    event.stopPropagation();

    const navMenu = arrow.closest('.nested-click-nav');

    if (!navMenu) return;

    const details = navMenu.querySelector(':scope > details');

    if (!details) return;

    const shouldOpen = !details.open;

    details.open = shouldOpen;

    arrow.setAttribute(
      'aria-expanded',
      shouldOpen ? 'true' : 'false'
    );

    return;
  }


  /* CLICKING THE CATEGORY NAME */
  const categoryLink = event.target.closest('.nested-submenu-link');

  if (categoryLink) {
    event.stopPropagation();
    return;
  }


  /*
    Clicking elsewhere inside the summary
    must NOT open the submenu.
  */
  const summary = event.target.closest('.nested-click-summary');

  if (summary) {
    event.preventDefault();
  }

});


document.addEventListener('keydown', function(event) {

  const arrow = event.target.closest('.nested-submenu-arrow');

  if (!arrow) return;

  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    arrow.click();
  }

});

  } catch(e) { console.error(e); }
})();
})();
